export default class NullStorage {
  get length(): number {
    return 0
  }
  getItem(key: string) {
    return null
  }
  setItem(key: string, data: string) {}
  clear() {}
  removeItem(key: string) {}
  key(index: number) {
    return null
  }
}
